

const translations = {
  greeting: {
    en: "Hello!",
    zh: "你好！"
  },
  name: {
    en: "Hanyang Huang",
    zh: "黄瀚阳"
  },
  nav: {
    home: { en: "Home", zh: "首页" },
    edu: { en: "Education", zh: "教育经历" },
    internship: { en: "Internship", zh: "实习经历" },
    contact: { en: "Contact", zh: "联系" },
    resume:{en:"Resume",zh:"简历"}
  },
  HoverHint:{
    en:"Click to show the detail",
    zh:"点击查看更多"
  },
  aboutTitle: {
    en: "About Me",
    zh: "关于我"
  },
  aboutText: {
    en: [
      "Hi! I'm Hanyang Huang, and I am a student in the Electrical and Computer Engineering program at McMaster University.",
      "With a solid engineering background, I am experienced in hardware development with microcontrollers, "
      +"skilled in front-end development, and capable of working on deep learning projects. Besides, I am fluent in English with a CLB 9 level. ",
      "Throughout my studies and project work, I have maintained a positive and diligent attitude, demonstrating creativity, reliability,"
      +" and strong teamwork skills. I enjoy taking on challenges and continuously strive to improve myself."
    ],
    zh: [
    "我叫黄瀚阳，本科毕业于南昌航空大学电子信息工程专业，现于 McMaster 大学攻读电子与计算机工程专业的工学硕士学位。",
    "拥有扎实的工程背景，我熟悉单片机的硬件开发，掌握前端开发技术，也具备深度学习项目开发的能力。英语流利，能够顺畅阅读技术文档并进行跨语言沟通。",
    "在学习与项目实践中，我始终保持积极乐观、勤奋踏实的态度，具备良好的创造力和团队协作精神，乐于迎接挑战并持续提升自我。"
  ]
  },
  timelineTitle:
  {
    en:"Overview",
    zh:"概述"
  },
  timelineContent:
  {
    first:{
      zh:[
        "设计并焊接电路，检测到有物体通过会进行计数",
        "",
        "逻辑电路；红外传感器；团队合作"
      ],
      en:[
        "Designed and soldered a circuit that counts ",
        "whenever an object passes by.",
        "",
        "Logic circuits; Infrared sensor; Team work "
      ]
    },
    second:{
      zh:[
        "通过两种算法自动寻路到达迷宫终点",
        "",
        "BFS; DFS; Python"
      ],
      en:[
        "Automatically navigated to the maze exit using two different pathfinding algorithms.",
        "",
        "BFS; DFS; Python"
      ]
    },
    third:{
      zh:[
        "通过温度传感器与单片机对温度进行测量与控制",
        "",
        "单片机，数模转换，PID控制"
      ],
      en:[
        "Measured and controlled temperature using a temperature sensor and microcontroller",
        "",
        "Microcontroller; Digital-to-analog conversion; PID"
      ]
    },
    fourth:{
      zh:[
        "浙江大华技术股份有限公司：",
        "前往项目现场为客户提供技术方面的支持与解决方案",
        "",
        "团队合作；沟通能力；智能安防；Linux"
      ],
      en:[
        "ZHEJIANGDAHUATECHNOLOGYCO.,LTD:",
        "Provided on-site technical support and solutions to clients.",
        "",
        "Teamwork; Comunication Skills; Smart security; Linux"
      ]
    },
    fifth:{
      zh:[
        "广州粤嵌通信科技股份有限公司：",
        "设计实现多媒体智能终端系统",
        "",
        "团队合作；嵌入式开发；Linux"
      ],
      en:[
        "Guangzhou YUQI Embedded Technology Co., Ltd.:",
        "Designed and implemented a multimedia intelligent terminal system.",
        "",
        "Teamwork; Embedded Development; Linux"
      ]
    },
    sixth:{
      zh:[
        "设计实现基于深度学习的声纹识别系统。",
        "",
        "Pytorch；语音处理；深度学习"
      ],
      en:[
        "Designed and implemented a speaker recognition system based on deep learning.",
        "",
        "PyTorch; Speech Processing; Deep Learning"
      ]
    },
    seventh:{
      zh:[
        "参与串口屏、蓝牙通信、监控平台和MPPT等模块的开发与测试，协助完成功能验证与稳定性分析。",
        "",
        "测试；蓝牙通讯；监控数据"
      ],
      en:[
        "Assisted in testing and development of serial display, Bluetooth, monitoring, and MPPT modules.",
        "",
        "Test; Bluetooth; Data Monitoring"
      ],
    },
    eighth:{
      zh:[
        "华天科技电子有限公司",
        "负责晶圆测试，检测晶圆上的每个裸芯片是否满足设计要求；",
        "",
        "Chip Probing; 晶圆测试；"
      ],
      en:[
        "HuaTian Tech Co., Ltd.:",
        "Responsible for wafer testing to verify whether each die on the wafer meets design specifications.",
        "",
        "Chip Probing; Wafer Testing"
      ]
    },
    nineth:{
      zh:[
        "Vosyn:",
        "负责基于 Linux 云平台的容器化部署与安全性配置，通过构建高效的自动化工作流整合跨部门业务需求，确保企业技术架构的稳定运行与数字化交付。；",
        "",
        "自动化集成; 云原生运维；跨部门协同"
      ],
      en:[
        "Vosyn Co., Ltd.:",
        "Spearheaded containerized deployment and security configuration on Linux cloud platforms, while orchestrating efficient n8n automation workflows to integrate cross-departmental business requirements, ensuring robust system architecture and seamless digital delivery.",
        "",
        "Automation Integration; Cloud-Native Operations;Cross-functional Collaboration"
      ]
    },
  },

  timelineModalContent:{
    first:{
      zh:[
        "随着生产力的提高与生产工具的飞速发展，饮料工厂也采取更加高效与卫生的流水线工艺，其中易拉罐的分装也逐渐采用自动化的装置。如何确定一定数量易拉罐为一箱的工作，不仅繁琐，生产人员也有疏忽记错的时候。为了解决这些问题，格外需要一款自动计数装置。本次课程设计将结合红外识别与自动计数装置模拟制作一款适用于生产线的计数装置。",
"此次设计结合《模拟电子电路》、《数字电路与逻辑设计》等课程的理论知识，采用multisim进行仿真，并用EDA绘制pcb板从而进行焊接。在完成所需的基本设计目标后，结合指导老师的意见进行创新和提高，实现切换不同的每箱易拉罐上限数量，蜂鸣器报警提醒即将满箱，计数的功能。",
"此次设计，实现了自动计数与报警功能，不仅提高了生产力，减轻了生产人员的工作量，而且以非接触的装置计数，确保产品的卫生与安全.",
        "",
        "逻辑电路；红外传感器；团队合作"
      ],
      en:[
 "Designed and soldered a circuit that counts ",
        "whenever an object passes by.",
        "",
        "Logic circuits; Infrared sensor; Team work "
      ]
    }



  },
  education: {
    title: { en: "Education Background", zh: "教育背景" },
    bachelor: { en: "Bachelor Period", zh: "本科阶段" },
    bachelorDesc: { 
      en: [
        "I completed my undergraduate studies at Nanchang Hangkong University, majoring in Electronic Information Engineering.",
        "Relevant coursework:Object-Oriented Programming (C++),Deep Learning (Python),Microprocessor Principles and Interface Technology (C51)，Linux System and Application",
        "GPA:3.72/4.00",
        "Honors and Awards:National Endeavor Scholarship,First-Class University Scholarship,Outstanding Student Award for Excellence in Morality, Intelligence, and Health"
      ], 
      zh: [
        "本科就读于南昌航空大学，主修电子信息工程专业。",
        "相关课程：面向对象程序设计(C++);深度学习（python);微处理器原理与接口技术（C51);Linux系统与设计",
        "GPA:3.72/4.00(前5%)",
        "所获荣誉：校一等奖学金；优秀三好学生"
       ],
          },
    undergradUni:{
      name:{zh:"南昌航空大学",en:"Nanchang Hangkong University"},
      major:{zh:"电子信息工程专业",en: "Electronic and Information Engineering"},
      schoolinfo:{zh:[
        "南昌航空大学是一所以工为主，工理文管经法教艺等学科协调发展的多科性大学，新中国最早成立的六所航空院校之一，博士学位授权单位。",
        "学校聚焦航空发动机和高端制造领域科技攻关，持续打造高水平科研平台。近日，太行国家实验室江西基地大楼建设项目正式备案，将建设高超声速风洞、高超飞行器动力推进等国家级重大科研平台。",
        "学校现有3个ESI全球前4‰学科，3个博士授权一级学科点，18个硕士学位授权一级学科点，科研创新能力持续提升，先后获国家技术发明奖、国家科技进步奖等国家级科研奖励，承担国家自然科学基金重点项目、国防军工项目等400余项"],
        en:[
          "Nanchang Hangkong University (NCHU) is a multi-disciplinary university with engineering as its main focus, featuring coordinated development in engineering, science, humanities, management, economics, law, education, and arts. It is an institution authorized to confer doctoral degrees.",
          "The university focuses on technological breakthroughs in advanced manufacturing and continues to build high-level research platforms. Recently, the construction project for the Jiangxi Base Building of the Taihang National Laboratory has been officially approved, aiming to establish national-level major research facilities such as a hypersonic wind tunnel and a propulsion platform for hypersonic vehicles.",
          "The university currently has three disciplines ranked in the global top 0.4% by ESI, three first-level doctoral degree authorization disciplines, and 18 first-level master's degree authorization disciplines. Its scientific research and innovation capacity continues to grow, with national-level awards such as the State Technological Invention Award and the National Science and Technology Progress Award, and over 400 projects funded by the National Natural Science Foundation of China and other major research programs."
        ]
      },
      majorinfo:{
        zh:[
          "南昌航空大学电子信息工程专业前身可追溯到1978年设立的电子仪器与测试技术专业，至今已有40余年办学积淀。专业依托学校鲜明的航空背景，聚焦航空电子与嵌入式技术方向，注重培养学生软硬件结合的工程应用能力。",
          "专业先后获批江西省品牌专业、国家特色专业、江西省一流专业及国家一流本科专业建设点，入选中国大学本科教育专业竞争力排行榜4星级，已通过工程教育专业认证受理。",
          "专业拥有省级单片机与嵌入式系统实验示范中心等4个特色实验室和学生科创空间，总面积2000平方米、设备总值近千万元，支撑学生实践创新。"
        ],
        en:[
          "The Electronic Information Engineering program at NCHU traces its origins back to the Electronic Instrumentation and Testing Technology program established in 1978, with over 40 years of development. Relying on the university's distinctive background, the program focuses on embedded technology and emphasizes cultivating students' engineering application abilities that integrate both hardware and software.",
          "The program has been recognized as a Jiangxi Province Brand Program, a National Specialty Program, a Jiangxi First-Class Specialty Program, and a National First-Class Undergraduate Program. It was rated as a four-star program in the China Undergraduate Program Competitiveness Rankings and has been accepted for engineering education accreditation.",
          "The program is equipped with four specialized laboratories, including a provincial-level Microcontroller and Embedded Systems Experimental Demonstration Center, and a student innovation space, covering a total area of 2,000 square meters with equipment worth nearly 10 million RMB, providing strong support for students' practical training and innovation."

        ]
      },
      link:{zh:"https://baike.baidu.com/item/%e5%8d%97%e6%98%8c%e8%88%aa%e7%a9%ba%e5%a4%a7%e5%ad%a6/3073271",
            en:"https://en.wikipedia.org/wiki/Nanchang_Hangkong_University"
      },
      schoolencyclopedia:{zh:"查看学校百科",
                          en:"View school encyclopedia"}
      },

    master: { en: "Master Period", zh: "硕士阶段" },
    masterDesc: {
      en: [
        "I am pursuing my master's degree at McMaster University, majoring in Electrical and Computer Engineering.",
        "Relevant coursework: Cloud computing(AWS), 3D image processing(pytorch), Machine Learning, Coding theory.",
        "GPA:3.92/4.00",
        "Expected graduation: June 2026"
      ],
      zh: [
        "硕士阶段就读于麦克马斯特大学，主修电子与计算机工程。",
        "相关课程：云计算（亚马逊云服务）； 3D图像处理(pytorch); 机器学习； 编码原理。",
        "GPA:3.92/4.00",
        "预计毕业时间：2026年6月"
      ]
    },
    graduateUni: {
      name: { zh: "麦克马斯特大学", en: "McMaster University" },
      major: { zh: "电子与计算机工程", en: "Electrical and Computer Engineering" },
      schoolinfo: {zh:[
        "麦克马斯特大学（McMaster University）是加拿大顶尖的研究型大学之一，学校的工程学院和DeGroote商学院在业内享有盛誉。是首个在英联邦拥有研究用核反应堆的高校，现有加拿大唯一的中等流量大学核反应堆（MNR），在核科学和高端制造领域优势突出。",
        "麦克马斯特大学是加拿大U15研究型大学联盟成员，长期以来在健康科学、工程技术、商学与社会科学等领域具有国际领先水平，科研设施先进，学术氛围开放包容，吸引了来自世界各地的优秀学者与学生，涌现出多位诺贝尔奖得主，凭借近130年的学术积淀，已成为国际上最具竞争力的博士授予大学之一，致力于产出应对全球挑战的高影响力研究成果。"],
        en:[
          "McMaster University is one of Canada’s top research-intensive universities, with its Faculty of Engineering and DeGroote School of Business both highly regarded in their fields. It was the first university in the Commonwealth to operate a research nuclear reactor, and it currently hosts Canada’s only medium-flux university reactor (the McMaster Nuclear Reactor, MNR), giving it a distinctive strength in nuclear science and advanced manufacturing.",
          "McMaster University is a member of the U15 Group of Canadian Research Universities and has long maintained international leadership in health sciences, engineering, business, and social sciences. With state-of-the-art research facilities and an open and inclusive academic environment, it attracts outstanding scholars and students from around the world. The university has produced multiple Nobel Prize winners and, with nearly 130 years of academic heritage, is recognized as one of the most globally competitive doctoral-granting institutions in Canada, dedicated to producing high-impact research that addresses global challenges."]
      },
      majorinfo:{
        zh:[
          "麦克马斯特大学 电气与计算机工程系（ECE） 在加拿大乃至国际上都享有盛誉，是该领域领先的院系之一。其工学硕士（MEng）项目致力于双重目标：一是帮助学生在电气与计算机工程的核心领域提升专业知识和技能，能够引领当前技术的实施与应用；二是培养学生理解和批判性评价新兴技术的能力，推动其将前沿技术应用于创新产品与服务的开发，服务本地、国家及全球社区的实际需求。",
          "该系拥有北美少有的先进研究平台——微纳系统研究中心（MNSL），支持多尺度材料、元件和器件的制造、表征和集成，例如纳米键合互连系统（NBIS）和纳米压印光刻系统（NIL），可用于纳米级结构和器件的制备与集成。研究内容涵盖从分子层面的基础键合机理，到健康与环境应用的新兴系统小型化等多个方向。"
        ],
        en:[
          "McMaster University’s Department of Electrical and Computer Engineering (ECE) is nationally and internationally recognized as one of the leading departments in its field. The Master of Engineering (MEng) program is designed with a dual focus: to strengthen students’ expertise in key areas of electrical and computer engineering, and to equip them with the ability to understand and critically evaluate technological advances so they can lead innovative applications that benefit communities worldwide.",
          "The department hosts cutting-edge research infrastructure, including the Centre for Research in Micro- and Nano-systems (MNSL) — one of the few facilities of its kind in North America. This centre enables fabrication, characterization, and integration of materials and devices at multiple length scales, such as with the Nano-Bonding and Interconnect System (NBIS) and Nanoimprinting Lithography System (NIL). Research at MNSL ranges from fundamental studies of molecular interactions to the miniaturization of systems for health and environmental applications."
        ]
      },
      link: {
        zh: "https://baike.baidu.com/item/%E9%BA%A6%E5%85%8B%E9%A9%AC%E6%96%AF%E7%89%B9%E5%A4%A7%E5%AD%A6/4384564?fromModule=search-result_lemma",
        en: "https://en.wikipedia.org/wiki/McMaster_University"
      },
      schoolencyclopedia:{zh:"查看学校百科",
                          en:"View school encyclopedia"}
    }   
  },

  contact:{
    para:{en:"If you are interested in my resume or projects, feel free to reach out via the following:",
      zh:"如果你对我的简历或项目感兴趣，欢迎通过以下方式与我联系"},
    Email:{gmail:"hanyanghuang0205@gmail.com",
      edu:"huanh81@mcmaster.ca"
    },
    
  },

 bachelorProjects: [
      {
        id: 'idiomDict',
        title: {
          zh: '成语词典管理系统',
          en: 'Chinese Idiom Dictionary Management System'
        },
        description: {
          zh: '独立开发 | C++/CLI + WinForms + MySQL Connector/C++',
          en: 'Independent project | C++/CLI + WinForms + MySQL Connector/C++'
        },
        sections: [
          {
            heading: { zh: '项目简介', en: 'Project Overview' },
            content: {
              zh: `这是我独立设计和开发的一个完整的 Windows 桌面应用程序，使用 C++/CLI + Windows Forms 编写，后端使用 MySQL Connector/C++ 实现与 MySQL 数据库的连接，系统用于对成语词典数据的增删改查管理。`,
              en: `This is a complete Windows desktop application that I independently designed and developed using C++/CLI with Windows Forms, using MySQL Connector/C++ for database connectivity with MySQL. The system manages an idiom dictionary with full CRUD operations.`
            }
          },
          {
            heading: { zh: '功能亮点', en: 'Key Features' },
            content: {
              zh: `• 实现对成语数据表的增删改查操作。\n• 支持多条件精准查询与模糊查询。\n• 使用 DataGridView 实时显示与刷新成语数据。\n• 支持通过拼音简码、成语、解释等字段组合查询。`,
              en: `• Full CRUD operations on the idiom data table.\n• Supports multi-condition precise and fuzzy searches.\n• Uses DataGridView for real-time display and refresh.\n• Supports combined queries by pinyin abbreviation, idiom, explanation, and other fields.`
            }
          },
          {
            heading: { zh: '技术细节', en: 'Technical Details' },
            content: {
              zh: `• 使用 MySQL Connector/C++ 实现与 MySQL 数据库的连接和操作。\n• 使用 DataGridView 绑定查询结果并实现动态刷新。\n• 完整流程涵盖数据库建模、SQL 脚本编写、UI 界面布局和事件封装。\n• 编写详细的异常处理和 MessageBox 提示，增强程序的稳定性与可维护性。`,
              en: `• Used MySQL Connector/C++ to connect and operate with the MySQL database.\n• Bound query results to DataGridView for dynamic refresh and display.\n• Covered the full workflow from database design and SQL scripting to UI layout and event handling.\n• Added detailed exception handling and MessageBox prompts for improved stability and maintainability.`
            }
          },
          {
            heading: { zh: '个人收获', en: 'Key Takeaways' },
            content: {
              zh: `• 独立完成从数据库到界面层的全流程开发。\n• 熟悉了 Windows Forms 控件、MySQL Connector/C++ 的使用及事件驱动编程。\n• 提升了对 C++/CLI 与 MySQL 集成的理解与调试能力。`,
              en: `• Independently completed the full development workflow from database to UI layer.\n• Gained hands-on experience with Windows Forms controls, MySQL Connector/C++, and event-driven programming.\n• Strengthened my understanding of integrating C++/CLI with MySQL and debugging real-world applications.`
            }
          }
        ],
        images: [
          {
            src: '/assets/img/idiomDict_img1.png',
            caption: { zh: '程序主界面', en: 'Main UI' }
          },
          {
            src: '/assets/img/idiomDict_img2.png',
            caption: { zh: '数据库设计示意', en: 'Database Design' }
          }
        ],
        videoUrl: ''
      },
      {
        id: 'audioPlayer',
        title: {
          zh: 'Python 音频播放器',
          en: 'Python Audio Player'
        },
        description: {
          zh: '独立开发 | Python + Tkinter + Pygame + MySQL',
          en: 'Independent project | Python + Tkinter + Pygame + MySQL'
        },
        sections: [
          {
            heading: { zh: '项目简介', en: 'Project Overview' },
            content: {
              zh: `这是我基于 Python 编程语言独立设计和开发的音频播放器，采用 Tkinter 实现图形用户界面（GUI），使用 Pygame 库进行音频加载、解码和播放，后台使用 MySQL 数据库存储音频元数据（如文件路径、标题、时长、上传时间），实现了对本地音频文件的导入、播放、暂停、音量与进度控制等功能，支持跨平台运行。`,
              en: `This is an audio player that I independently designed and developed using Python. It uses Tkinter for the graphical user interface (GUI) and Pygame for audio loading, decoding, and playback. It uses a MySQL database to store audio metadata (such as file paths, titles, duration, and upload time), supporting importing, playing, and pausing local audio files as well as volume and progress control. The system is cross-platform.`
            }
          },
          {
            heading: { zh: '功能亮点', en: 'Key Features' },
            content: {
              zh: `• 使用 Tkinter 设计简洁直观的界面，包含按钮、进度条、音量滑块等。\n• 使用 Pygame 加载与播放音频，支持 WAV、MP3、OGG 等格式。\n• 可以音频播放进度和音量; 支持播放/暂停按钮状态动态切换; 支持寻址操作与循环播放。`,
              en: `• Designed a clean and intuitive UI with Tkinter, including buttons, progress bars, and volume sliders.\n• Used Pygame to load and play audio, supporting formats like WAV, MP3, and OGG.\n• Supports audio playback progress and volume control; dynamic toggle between play/pause button states; seeking and loop playback are supported.`
            }
          },
          {
            heading: { zh: '技术细节', en: 'Technical Details' },
            content: {
              zh: `• 使用 Pygame 的音频模块实现加载、解码和播放， 并可以获取与设置播放位置。\n• 使用 Tkinter 的可变字符串和按钮状态管理实现交互逻辑，结合 Scale 实现进度条与音量滑块。\n• 使用  PyMySQ与 MySQL 数据库进行连接，读写音频文件的元信息。\n• 数据库表包含文件路径、标题、时长、创建时间等字段，表结构简洁、易扩展。\n• 充分考虑多格式兼容、跨平台运行与用户交互的流畅性。`,
              en: `• Implemented audio loading, decoding, and playback using Pygame's audio modules,as well as playback position control.\n• Managed interactive logic using Tkinter's variable strings and button state toggling, combined with Scale widgets for progress and volume control.\n• Connected to a MySQL database using  PyMySQL to read and store audio file metadata.\n• The database table stores file paths, titles, duration, and creation time, with a clean and extensible structure.\n• Ensured compatibility with multiple audio formats, smooth cross-platform operation, and user-friendly interaction.`
            }
          },
          {
            heading: { zh: '个人收获', en: 'Key Takeaways' },
            content: {
              zh: `• 独立完成从数据库设计、Python 与 MySQL 的连接实现到 GUI 和音频播放的全流程。\n• 熟悉了 Pygame 音频模块与 Tkinter 的 GUI 编程及状态管理。\n• 提升了对多线程用户交互、控件状态切换和跨平台多媒体处理的理解与调试能力。`,
              en: `• Independently completed the full workflow from database design and Python-MySQL integration to GUI and audio playback.\n• Gained practical experience with Pygame audio modules and Tkinter GUI programming and state management.\n• Enhanced understanding and debugging skills in multi-threaded user interaction, widget state toggling, and cross-platform multimedia processing.`
            }
          }
        ],
        images: [
          {
            src: '/assets/img/audioPlayer_ui.png',
            caption: { zh: '音频播放器界面', en: 'Audio Player UI' }
          },
          {
            src: '/assets/img/audioPlayer_db.png',
            caption: { zh: '数据库结构示意', en: 'Database Structure' }
          }
        ],
        videoUrl: ''
      },

        {
          "id": "infraredCounter",
          "title": {
            "zh": "红外物体计数与智能报警系统",
            "en": "Infrared Object Counting and Smart Alert System"
          },
          "description": {
            "zh": "独立设计开发 | Multisim 仿真 + EDA PCB设计 + 模拟/数字电路集成",
            "en": "Independently Designed | Multisim Simulation + EDA PCB Design + Analog/Digital Circuit Integration"
          },
          "sections": [
            {
              "heading": { "zh": "项目简介", "en": "Project Overview" },
              "content": {
                "zh": "该系统由本人独立设计开发，通过红外检测、信号整形、计数显示及声光报警，实现对物体的自动计数与上限预警，完成从电路原理图、仿真验证、PCB 布局到焊接调试的全流程。",
                "en": "This system was independently designed and developed by myself, integrating infrared sensing, signal shaping, counting display, and audio-visual alerts to automatically count objects and provide upper-limit warnings. The full workflow includes schematic design, simulation verification, PCB layout, soldering, and debugging."
              }
            },
            {
              "heading": { "zh": "功能亮点", "en": "Key Features" },
              "content": {
                "zh": "• 灵活设置计数上限，自动切换阈值并触发报警。\n• 实时计数显示，声光双重提醒，操作直观。\n• 高灵敏度红外非接触检测，生成稳定脉冲信号。",
                "en": "• Flexible upper limit configuration with automatic threshold switching and alert triggering.\n• Real-time counting display with intuitive dual audio-visual alerts.\n• High-sensitivity non-contact infrared detection generates stable pulse signals."
              }
            },
            {
              "heading": { "zh": "技术细节", "en": "Technical Details" },
              "content": {
                "zh": "• 红外对管检测与 NE555 触发器整形脉冲信号。\n• 74LS161 级联计数，4511BD 译码驱动数码管显示。\n• 完成 Multisim 仿真、EDA PCB 设计及实物焊接调试，保证电路稳定可靠。",
                "en": "• Infrared emitter-receiver pair with NE555 Schmitt trigger for pulse shaping.\n• Cascaded 74LS161 counters with 4511BD decoder driving the 7-segment display.\n• Completed Multisim simulation, EDA PCB design, and physical soldering/debugging, ensuring circuit stability and reliability."
              }
            },
            {
              "heading": { "zh": "个人收获", "en": "Key Takeaways" },
              "content": {
                "zh": "• 独立完成从方案设计到焊接调试的闭环开发流程。\n• 提升了红外检测、模拟/数字电路集成与 PCB 制作能力。\n• 掌握了多模块电路联合调试及问题定位技巧。",
                "en": "• Independently completed the closed-loop workflow from design to soldering and debugging.\n• Enhanced skills in infrared sensing, analog/digital circuit integration, and PCB fabrication.\n• Gained experience in multi-module circuit debugging and troubleshooting."
              }
            }
          ],
          "images": [
            {
              "src": "/assets/img/infraredCounter_img1.png",
              "caption": { "zh": "仿真与原理图", "en": "Simulation & Schematic" }
            },
            {
              "src": "/assets/img/infraredCounter_img2.png",
              "caption": { "zh": "焊接成品", "en": "Finished Soldered Hardware" }
            }
          ],
          "videoUrl": ""
        },

        {
          "id": "tempSensorSystem",
          "title": {
            "zh": "基于 V-F 转换的数字温度测量系统",
            "en": "Digital Temperature Measurement System Based on V-F Conversion"
          },
          "description": {
            "zh": "独立设计开发 | PT100 + AD623 + LM331 V-F转换 + STC89C51 多模块集成",
            "en": "Independently Designed | PT100 + AD623 + LM331 V-F Conversion + STC89C51 Multi-Module Integration"
          },
          "sections": [
            {
              "heading": { "zh": "项目简介", "en": "Project Overview" },
              "content": {
                "zh": "该系统由本人独立设计开发，采用 PT100 作为高精度温度传感器，AD623 放大电路对微弱信号进行差分放大后，通过 LM331 芯片实现核心的电压-频率（V-F）转换，将模拟信号精准转换为适合单片机处理的数字频率信号，最后由 STC89C51 单片机进行数据采集、处理与多模式显示，实现了可靠的温度监测与人机交互。",
                "en": "This system was independently designed and developed, using a PT100 as a high-precision temperature sensor. The AD623 amplifier circuit differentially amplifies weak signals, and the LM331 chip performs the key voltage-to-frequency (V-F) conversion, accurately transforming analog signals into digital frequency signals for easier microcontroller processing. The STC89C51 microcontroller handles data acquisition, processing, and multi-mode display, achieving reliable temperature monitoring with human-machine interaction."
              }
            },
            {
              "heading": { "zh": "功能亮点", "en": "Key Features" },
              "content": {
                "zh": "• PT100 高精度测温，AD623 差分放大提高信噪比。\n• 核心 V-F 转换模块（LM331）高效实现模拟到数字转换。\n• 单片机完成频率采集、数据处理及 LCD/LED 多模式显示。\n• 矩阵键盘与蜂鸣器拓展人机交互及超温报警功能。",
                "en": "• High-precision PT100 temperature measurement with AD623 differential amplification for improved SNR.\n• Core V-F conversion module (LM331) efficiently converts analog signals to digital.\n• Microcontroller performs frequency acquisition, data processing, and multi-mode LCD/LED display.\n• Matrix keyboard and buzzer enhance human-machine interaction and over-temperature alerts."
              }
            },
            {
              "heading": { "zh": "技术细节", "en": "Technical Details" },
              "content": {
                "zh": "• PT100 与 AD623 差分放大电路提升测量灵敏度和稳定性。\n• LM331 芯片核心 V-F 转换实现高线性、高抗干扰模拟到数字转换。\n• STC89C51 单片机基于频率信号完成数据采集和处理。\n• LCD 与 LED 组合显示，矩阵键盘与蜂鸣器完善交互体验。",
                "en": "• PT100 with AD623 differential amplifier improves measurement sensitivity and stability.\n• LM331 chip provides core V-F conversion with high linearity and strong anti-interference for analog-to-digital transformation.\n• STC89C51 microcontroller processes data based on the frequency signal.\n• Combined LCD and LED display; matrix keyboard and buzzer enhance interactive experience."
              }
            },
            {
              "heading": { "zh": "个人收获", "en": "Key Takeaways" },
              "content": {
                "zh": "• 独立完成从模拟测量、V-F 转换到单片机编程的完整流程。\n• 深入理解 V-F 转换原理及其在传感器信号处理中的应用。\n• 提升了多模块集成与系统调试能力。",
                "en": "• Independently completed the full process from analog measurement and V-F conversion to microcontroller programming.\n• Gained in-depth understanding of V-F conversion principles and their application in sensor signal processing.\n• Enhanced skills in multi-module integration and system debugging."
              }
            }
          ],
          "images": [
            {
              "src": "/assets/img/tempSensorSystem_img1.png",
              "caption": { "zh": "系统原理图", "en": "System Schematic" }
            },
            {
              "src": "/assets/img/tempSensorSystem_img2.png",
              "caption": { "zh": "调试与显示界面", "en": "Debugging & Display Interface" }
            }
          ],
          "videoUrl": ""
        },
        {
            "id": "smartBellTimer",
            "title": {
              "zh": "智能定时打铃器软件设计",
              "en": "Smart Bell Timer Software Design"
            },
            "description": {
              "zh": "独立编程 | C51 单片机定时/中断/人机交互控制",
              "en": "Independent Programming | C51 MCU Timing/Interrupt/HMI Control"
            },
            "sections": [
              {
                "heading": { "zh": "项目简介", "en": "Project Overview" },
                "content": {
                  "zh": "本项目为智能定时打铃器的软件部分，由本人独立完成 C51 单片机程序设计。整体功能实现了时间显示、计时、矩阵键盘输入打铃时间、定时中断触发打铃输出及蜂鸣报警等，支持最多十组打铃时间设置，具备基本人机交互能力。",
                  "en": "This project focuses on the software part of a smart bell timer, independently developed using C51 microcontroller programming. The system implements time display, timekeeping, matrix keyboard input for setting up to ten bell times, timer interrupt-driven bell output, and buzzer alarm, providing basic human-machine interaction functionality."
                }
              },
              {
                "heading": { "zh": "功能亮点", "en": "Key Features" },
                "content": {
                  "zh": "• 多模块整合：显示、计时、按键输入、定时输出分模块独立设计。\n• 支持最多十组打铃时间设定，每组可精确到时分。\n• 中断机制精准计时与打铃，打铃时长可灵活调节。\n• 矩阵键盘实现时分调整与打铃时间切换，人机交互简单高效。",
                  "en": "• Multi-module integration: display, timekeeping, keyboard input, and timed output are independently designed and coordinated.\n• Supports up to ten bell time settings with hour-minute precision.\n• Interrupt mechanism ensures precise timing and bell triggering, with adjustable ringing duration.\n• Matrix keyboard allows intuitive time adjustment and bell time switching for simple and efficient HMI."
                }
              },
              {
                "heading": { "zh": "技术细节", "en": "Technical Details" },
                "content": {
                  "zh": "• 使用定时器 T0 中断实现 10ms 级时间基准，计时逻辑可靠。\n• 主程序负责模块调度，分标志位和打铃标志位确保状态同步。\n• 键盘扫描与输入设置模块支持多按键功能，如设置、移位、增减位。\n• 可与 LED 显示或 LCD 扩展联动，实时显示当前时间和设定时间。",
                  "en": "• Uses Timer 0 interrupts to implement a 10ms time base, ensuring reliable timekeeping logic.\n• Main program coordinates modules with flag bits for minute and bell status to maintain synchronized states.\n• Keyboard scanning and input modules support multi-key functionality, including setting, shifting, and increment/decrement operations.\n• Designed to work with LED or LCD display for real-time display of current and set times."
                }
              },
              {
                "heading": { "zh": "个人收获", "en": "Key Takeaways" },
                "content": {
                  "zh": "• 独立完成基于 C51 的多模块嵌入式程序设计。\n• 熟练掌握定时器/中断与矩阵键盘的人机交互实现。\n• 加深对程序结构化设计、状态机与模块调度的理解。",
                  "en": "• Independently completed multi-module embedded software design based on C51.\n• Gained hands-on experience with timer/interrupt mechanisms and matrix keyboard HMI implementation.\n• Deepened understanding of structured programming, state machines, and module scheduling."
                }
              }
            ],
            "images": [
              {
                "src": "/assets/img/smartBellTimer_img1.png",
                "caption": { "zh": "软件仿真示意图", "en": "Software Simulation Diagram" }
              }
            ],
            "videoUrl": ""
          },

          {
            "id": "trafficLightController",
            "title": {
              "zh": "基于 VHDL 的交通灯控制系统设计",
              "en": "Traffic Light Control System Design Based on VHDL"
            },
            "description": {
              "zh": "VHDL 状态机 + 分频器 + 倒计时显示",
              "en": "VHDL State Machine + Frequency Divider + Countdown Display"
            },
            "sections": [
              {
                "heading": { "zh": "项目简介", "en": "Project Overview" },
                "content": {
                  "zh": "本项目独立使用 VHDL 语言设计了一个简易十字路口交通灯控制系统，基于状态机和分频器实现红绿黄灯自动切换、黄灯闪烁提示，并通过七段数码管动态显示东西/南北通行剩余时间，完整体现了交通信号控制的基本工作原理。",
                  "en": "This project independently uses VHDL to design a simple intersection traffic light control system. It implements automatic switching of red, green, and yellow lights using a state machine and frequency divider, with yellow light flashing warnings and real-time remaining time display on a 7-segment display, fully demonstrating the basic principles of traffic signal control."
                }
              },
              {
                "heading": { "zh": "功能亮点", "en": "Key Features" },
                "content": {
                  "zh": "• 基于状态机的交通灯状态自动切换：东西与南北方向轮流通行。\n• 使用分频器生成 1Hz 和 2Hz 时钟，分别用于倒计时和黄灯闪烁。\n• 七段数码管动态显示剩余时间，随状态同步递减。\n• 支持按键复位，确保系统可重复启动，仿真验证切换逻辑正确。",
                  "en": "• Automatic state switching based on a state machine: east-west and north-south directions take turns.\n• Frequency divider generates 1Hz and 2Hz clocks for countdown and yellow light flashing.\n• 7-segment display dynamically shows remaining time, synchronized with state transitions.\n• Supports button reset for repeated operation; simulation verifies correct switching logic."
                }
              },
              {
                "heading": { "zh": "技术细节", "en": "Technical Details" },
                "content": {
                  "zh": "• 系统时钟输入为 1KHz，通过分频计数器生成 0.5Hz/1Hz/2Hz。\n• 倒计时模块 SEC1 和 SEC10 分别管理个位与十位数字递减。\n• 黄灯闪烁逻辑通过 Clk1Hz 驱动，当剩余时间小于 3 秒时启用 2Hz 闪烁。\n• 使用 LED 模拟红、黄、绿灯，七段数码管实时显示通行方向及剩余时间。",
                  "en": "• System clock input is 1KHz, divided to generate 0.5Hz/1Hz/2Hz.\n• Countdown module uses SEC1 and SEC10 to handle units and tens digits decrementing.\n• Yellow light flashing logic is driven by Clk1Hz; when remaining time is less than 3 seconds, a 2Hz clock triggers flashing.\n• LEDs simulate red, yellow, and green lights; 7-segment display shows traffic direction and remaining time in real time."
                }
              },
              {
                "heading": { "zh": "个人收获", "en": "Key Takeaways" },
                "content": {
                  "zh": "• 独立完成 VHDL 状态机和分频器设计，掌握交通灯控制逻辑。\n• 熟悉七段数码管动态显示原理及倒计时实现。\n• 提升了对同步/异步时序电路及仿真验证的理解。",
                  "en": "• Independently completed VHDL state machine and frequency divider design, mastering traffic light control logic.\n• Became familiar with dynamic 7-segment display principles and countdown implementation.\n• Improved understanding of synchronous/asynchronous sequential circuits and simulation verification."
                }
              }
            ],
            "images": [],
            "videoUrl": ""
          },

              {
                "id": "simpleClock",
                "title": {
                  "zh": "基于 VHDL 的简易时钟设计",
                  "en": "Simple Clock Design Based on VHDL"
                },
                "description": {
                  "zh": "独立编程 | VHDL 底层模块 + 原理图顶层集成 + 数码管动态显示",
                  "en": "Independent Programming | VHDL Bottom Modules + Schematic Top-Level Integration + Dynamic 7-Segment Display"
                },
                "sections": [
                  {
                    "heading": { "zh": "项目简介", "en": "Project Overview" },
                    "content": {
                      "zh": "该设计通过 VHDL 独立完成秒、分、时计数模块与数码管显示译码模块，并用原理图输入法集成为简易时钟顶层电路，成功实现数码管动态显示时-分-秒，并经仿真验证功能正确。",
                      "en": "This design independently implements second, minute, and hour counting modules and a 7-segment display decoder module using VHDL. Modules are integrated into a simple clock top-level circuit via schematic entry, successfully achieving dynamic hour-minute-second display with simulation verifying its correctness."
                    }
                  },
                  {
                    "heading": { "zh": "功能亮点", "en": "Key Features" },
                    "content": {
                      "zh": "• VHDL 编写模 60、模 24 同步计数器。\n• 数码管显示译码支持 8 位动态扫描。\n• 原理图输入法完成模块级联和信号连接。\n• 仿真验证时钟从 23:59:59 自动回到 00:00:00。",
                      "en": "• VHDL-coded mod-60 and mod-24 synchronous counters.\n• 7-segment display decoder supports 8-digit dynamic scanning.\n• Schematic entry used for module cascading and signal wiring.\n• Simulation verifies correct looping from 23:59:59 to 00:00:00."
                    }
                  },
                  {
                    "heading": { "zh": "技术细节", "en": "Technical Details" },
                    "content": {
                      "zh": "• 秒、分模块采用模 60 同步计数器，小时模块为模 24。\n• 子模块封装为图元 (*.bsf) 供顶层电路调用。\n• 数码管动态扫描使用地址选择信号。\n• 使用 Quartus 原理图输入法集成、编译和仿真。",
                      "en": "• Second and minute modules use mod-60 synchronous counters; hour module is mod-24.\n• Submodules packaged as symbol files (*.bsf) for top-level reuse.\n• 7-segment display uses address selection for dynamic scanning.\n• Integrated, compiled, and simulated in Quartus using schematic entry."
                    }
                  },
                  {
                    "heading": { "zh": "个人收获", "en": "Key Takeaways" },
                    "content": {
                      "zh": "• 熟悉 VHDL 模块化设计与封装流程。\n• 掌握原理图输入法的顶层集成方法。\n• 提升了对时序电路设计和仿真的理解与调试能力。",
                      "en": "• Became familiar with modular VHDL design and packaging.\n• Mastered schematic entry for top-level integration.\n• Improved understanding and debugging of sequential circuit design and simulation."
                    }
                  }
                ],
                "images": [
                  {
                    "src": "/assets/img/simpleClock_schematic.png",
                    "caption": { "zh": "顶层原理图示意", "en": "Top-Level Schematic Diagram" }
                  },
                  {
                    "src": "/assets/img/simpleClock_waveform.png",
                    "caption": { "zh": "仿真波形结果", "en": "Simulation Waveform Result" }
                  }
                ],
                "videoUrl": ""
              },

               {
                  "id": "mazeRouter",
                  "title": {
                    "zh": "Python迷宫路由与算法可视化",
                    "en": "Python Maze Routing and Algorithm Visualization"
                  },
                  "description": {
                    "zh": "Python 迷宫生成 + BFS/DFS 路由 + Pyxel 可视化演示",
                    "en": "Python Maze Generation + BFS/DFS Routing + Pyxel Visualization Demo"
                  },
                  "sections": [
                    {
                      "heading": { "zh": "项目简介", "en": "Project Overview" },
                      "content": {
                        "zh": "该设计以迷宫路由为题，使用 Python 独立实现 N×M（行列可配置）迷宫的随机生成与存储，并基于广度优先搜索（BFS）与深度优先搜索（DFS）两种算法进行路径搜索，采用 Pyxel 库将搜索过程可视化并动态呈现，直观对比两种搜索思路的差异。",
                        "en": "This project focuses on maze routing, independently implemented in Python to generate, organize, and store an N×M maze (with configurable rows and columns). It uses Breadth-First Search (BFS) and Depth-First Search (DFS) for pathfinding and visualizes the search process dynamically using the Pyxel library, providing an intuitive comparison of the two search strategies."
                      }
                    },
                    {
                      "heading": { "zh": "功能亮点", "en": "Key Features" },
                      "content": {
                        "zh": "• 随机生成连通迷宫，支持用户自定义规模（默认 50×50）。\n• 入口位于第0行，出口位于第N-1行，保证可解。\n• 分别实现 BFS（队列）与 DFS（栈）算法，求解路径并实时可视化。\n• 使用 Pyxel 渲染迷宫和搜索动画，操作流畅，效果清晰。\n• 在多个迷宫实例上进行算法对比实验，并输出时空复杂度分析。",
                        "en": "• Randomly generates a connected maze with user-configurable size (default 50×50).\n• Entry on row 0 and exit on row N-1, ensuring solvability.\n• Implements BFS (queue) and DFS (stack) algorithms to solve the maze with real-time visualization.\n• Uses Pyxel to render the maze and search animation, providing smooth and clear visual effects.\n• Runs comparative experiments on multiple maze instances and outputs time and space complexity analysis."
                      }
                    },
                    {
                      "heading": { "zh": "技术细节", "en": "Technical Details" },
                      "content": {
                        "zh": "• 使用栈（DFS）与队列（BFS）分别实现路径搜索，基于 Python 内置数据结构与自定义迷宫类。\n• Pyxel 实现轻量级 2D 渲染，实时绘制迷宫格子与搜索路径。\n• 自动记录搜索遍历节点数与耗时，用于后续生成对比报告。\n• 支持批量生成不同规模迷宫进行实验验证。",
                        "en": "• Uses stack (DFS) and queue (BFS) to implement pathfinding based on Python built-in data structures and a custom maze class.\n• Pyxel enables lightweight 2D rendering to draw maze grids and search paths in real time.\n• Automatically records the number of visited nodes and runtime for comparative reporting.\n• Supports batch generation of mazes of different sizes for experimental verification."
                      }
                    },
                    {
                      "heading": { "zh": "个人收获", "en": "Key Takeaways" },
                      "content": {
                        "zh": "• 熟练掌握了 BFS 与 DFS 的原理及 Python 实现。\n• 深入理解了栈、队列在不同搜索策略中的作用及效率差异。\n• 掌握了 Pyxel 的基础用法，提升了算法可视化能力。\n• 学会从理论与实验角度对比算法时空复杂度。",
                        "en": "• Gained proficiency in BFS and DFS principles and Python implementation.\n• Deepened understanding of the role and efficiency differences of stacks and queues in different search strategies.\n• Learned the basics of Pyxel, improving algorithm visualization skills.\n• Learned to compare algorithm time and space complexity from both theoretical and experimental perspectives."
                      }
                    }
                  ],
                  "images": [
                    {
                      "src": "/assets/img/mazeRouter_bfs.png",
                      "caption": { "zh": "BFS 路由路径示例", "en": "BFS Routing Path Example" }
                    },
                    {
                      "src": "/assets/img/mazeRouter_dfs.png",
                      "caption": { "zh": "DFS 路由路径示例", "en": "DFS Routing Path Example" }
                    }
                  ],
                  "videos": [
                    {
                      "src": "/assets/video/mazeRouter_bfs_demo.mp4",
                      "caption": { "zh": "BFS 搜索过程演示", "en": "BFS Search Demo" }
                    },
                    {
                      "src": "/assets/video/mazeRouter_dfs_demo.mp4",
                      "caption": { "zh": "DFS 搜索过程演示", "en": "DFS Search Demo" }
                    }
                  ]
                },

                {
                    "id": "speakerRecognition",
                    "title": {
                      "zh": "基于深度学习的说话人识别方法设计",
                      "en": "Design of Speaker Recognition Method Based on Deep Learning"
                    },
                    "description": {
                      "zh": "本科毕业设计 | 语音信号预处理 + Fbank特征提取 + ECAPA-TDNN模型 + PyTorch 实现",
                      "en": "Undergraduate Thesis | Speech Signal Preprocessing + Fbank Feature Extraction + ECAPA-TDNN Model + PyTorch Implementation"
                    },
                    "sections": [
                      {
                        "heading": { "zh": "研究背景", "en": "Research Background" },
                        "content": {
                          "zh": "随着科技发展和安全需求提升，人们对身份验证技术提出了更高要求。说话人识别作为一种基于声音生物特征的身份识别手段，具有个性化、非接触式等优势，但传统方法在复杂环境下表现不佳，深度学习的发展推动了声纹识别的准确率和鲁棒性提升。",
                          "en": "With technological advancement and growing security needs, higher standards have been set for identity verification. Speaker recognition, based on vocal biometrics, offers personalized, contactless authentication. However, traditional methods often perform poorly in complex environments; the development of deep learning has significantly improved the accuracy and robustness of voiceprint recognition."
                        }
                      },
                      {
                        "heading": { "zh": "研究内容", "en": "Research Content" },
                        "content": {
                          "zh": "本设计基于 Pytorch 框架，采用 Kaldi 进行语音信号的预加重、分帧、加窗、端点检测及 Fbank 特征提取；核心模型为 ECAPA-TDNN，包含 SE-Res2Block 空洞卷积模块、依赖通道和上下文的统计池化、多层特征聚合等结构创新，提升了说话人判别特征的表达能力。",
                          "en": "This design, based on the Pytorch framework, uses Kaldi for speech signal pre-emphasis, framing, windowing, endpoint detection, and Fbank feature extraction. The core model is ECAPA-TDNN, which includes SE-Res2Block with dilated convolution, channel-and-context dependent statistical pooling, and multi-layer feature aggregation to enhance the discriminative power of speaker features."
                        }
                      },
                      {
                        "heading": { "zh": "所用方法与实验", "en": "Methods and Experiments" },
                        "content": {
                          "zh": "• 数据集：CN-Celeb 与 CN-Celeb2，覆盖11种题材，音频采样16kHz。\n• 预处理：一阶高通滤波器预加重、25ms帧长/10ms帧移分帧、Povey窗加窗、能量门限法端点检测。\n• 特征提取：基于 Kaldi 提取 Fbank 声纹特征。\n• 网络结构：一维 SE-Res2Block 空洞卷积（扩张率 2/3/4），统计池化，AAM-SoftMax 分类器。\n• 实验环境：Windows 11，Anaconda 虚拟环境管理 Pytorch1.13.1，Python3.8，PyCharm 编辑调试。",
                          "en": "• Datasets: CN-Celeb and CN-Celeb2, covering 11 topics, audio sampled at 16kHz.\n• Preprocessing: first-order high-pass filter pre-emphasis, 25ms frame length / 10ms frame shift framing, Povey windowing, energy threshold endpoint detection.\n• Feature extraction: Fbank features extracted using Kaldi.\n• Network: 1D SE-Res2Block with dilated convolution (dilation rates 2/3/4), statistical pooling, AAM-SoftMax classifier.\n• Experimental setup: Windows 11, Anaconda-managed Pytorch1.13.1 virtual environment, Python 3.8, PyCharm for code editing and debugging."
                        }
                      },
                      {
                        "heading": { "zh": "实验结果", "en": "Experimental Results" },
                        "content": {
                          "zh": "• 在验证集上，模型 EER = 0.09989，MinDCF = 0.56357。\n• 准确率与损失曲线平滑收敛，最终判别阈值约为0.231。\n• 通过绘制 FNR 与 FPR 曲线，验证了模型的可分性与鲁棒性。",
                          "en": "• On the validation set, the model achieved EER = 0.09989 and MinDCF = 0.56357.\n• Accuracy and loss curves converge smoothly, with a final decision threshold around 0.231.\n• FNR and FPR curves demonstrate the model's separability and robustness."
                        }
                      },
                      {
                        "heading": { "zh": "总结与展望", "en": "Conclusion and Outlook" },
                        "content": {
                          "zh": "• 本文完成了从语音信号预处理、特征提取到 ECAPA-TDNN 模型训练及部署的完整流程，验证了深度学习在说话人识别中的可行性与优势。\n• 未来可在多说话人识别、会议转写、金融安防、个性化智能助手等领域继续深入探索。",
                          "en": "• This thesis completed the full workflow from speech signal preprocessing and feature extraction to ECAPA-TDNN training and deployment, validating the feasibility and advantages of deep learning for speaker recognition.\n• Future work may further explore applications in multi-speaker recognition, meeting transcription, financial security, and personalized intelligent assistants."
                        }
                      }
                    ],
                    "images": [
                              {
                                "src": "/assets/img/speakerRecognition_flow.png",
                                "caption": {
                                  "zh": "系统流程图",
                                  "en": "System Flowchart"
                                },
                                "lang": "zh"
                              },
                                {
                                "src": "/assets/img/speakerRecognition_flow_en.png",
                                "caption": {
                                  "zh": "系统流程图",
                                  "en": "System Flowchart"
                                },
                                "lang": "en"
                              },
                              {
                                "src": "/assets/img/speakerRecognition_fnr_fpr.png",
                                "caption": {
                                  "zh": "FNR 与 FPR 曲线",
                                  "en": "FNR and FPR Curve"
                                }
                              },
                              {
                                "src": "/assets/img/speakerRecognition_accuracy.png",
                                "caption": {
                                  "zh": "训练准确率曲线",
                                  "en": "Training Accuracy Curve"
                                }
                              },
                              {
                                "src": "/assets/img/speakerRecognition_loss.png",
                                "caption": {
                                  "zh": "训练损失率曲线",
                                  "en": "Training Loss Curve"
                                }
                              }
                            ],
                    "videos": []
                  }










  ],

  masterProjects: [
        {
          "id": "maskDetection",
          "title": {
            "zh": "基于 Faster R-CNN 的口罩检测",
            "en": "Mask Detection Based on Faster R-CNN"
          },
          "description": {
            "zh": "Faster R-CNN + 迁移学习 + 多场景口罩检测",
            "en": "Faster R-CNN + Transfer Learning + Multi-Scenario Mask Detection"
          },
          "sections": [
            {
              "heading": { "zh": "研究背景", "en": "Research Background" },
              "content": {
                "zh": "在公共场所防控传染病的需求下，口罩佩戴状态的自动检测具有重要的实际意义。传统人工巡查方式存在检测范围有限、主观性强和无法持续运行等问题，随着深度学习与目标检测技术的发展，基于卷积神经网络的检测模型为提高检测精度和效率提供了可行方案。",
                "en": "In the context of preventing infectious diseases in public places, automatic detection of mask-wearing status has significant practical value. Traditional manual inspection methods have limitations such as limited coverage, subjective judgment, and inability to operate continuously. With the development of deep learning and object detection technology, CNN-based detection models offer a feasible solution to improve detection accuracy and efficiency."
              }
            },
            {
              "heading": { "zh": "研究内容", "en": "Research Content" },
              "content": {
                "zh": "本项目设计并实现了一个基于 Faster R-CNN 的自动口罩检测系统，支持检测“正确佩戴”、“未佩戴”及“佩戴不当”三种状态，并支持多人人脸同时检测。项目结合迁移学习方法，对 COCO 预训练模型进行微调，保证在小样本数据集上的有效收敛和泛化能力，目标场景涵盖商场、校园、地铁等人群密集场所。",
                "en": "This project designs and implements an automatic mask detection system based on Faster R-CNN, capable of detecting three states: correctly worn, not worn, and improperly worn. It supports simultaneous detection of multiple faces. The project combines transfer learning to fine-tune a COCO pre-trained model, ensuring effective convergence and generalization on a small-scale dataset. Target scenarios include crowded places such as malls, campuses, and subways."
              }
            },
            {
              "heading": { "zh": "所用方法与实验", "en": "Methodology and Experiment" },
              "content":{
                          "zh": "• 数据集：选用 Kaggle 的 853 张人脸口罩检测图像，覆盖多场景和多光照，Pascal VOC 格式标注。\n• 预处理：图像格式转换、归一化，支持多标签和自定义数据集加载。\n• 模型框架：基于 Faster R-CNN 两阶段检测，骨干网络为 ResNet-50 + FPN，RPN 生成候选框，ROI Align 精确特征对齐。\n• 训练策略：使用 COCO 预训练权重做迁移学习，分类头改为 3 类，采用 AdamW 优化器，学习率逐步衰减。",
                          "en": "• Dataset: Selected 853 face mask detection images from Kaggle covering various scenes and lighting conditions, annotated in Pascal VOC format.\n• Preprocessing: Image format conversion and normalization, supports multi-label and custom dataset loading.\n• Model framework: Based on Faster R-CNN two-stage detection with ResNet-50 + FPN backbone, RPN for region proposals, ROI Align for precise feature alignment.\n• Training strategy: Transfer learning with COCO pre-trained weights, classification head adjusted for 3 classes, using AdamW optimizer with gradually decaying learning rate."
                        }
            },
            {
              "heading": { "zh": "实验结果", "en": "Experimental Results" },
              "content": {
                "zh": "• 损失曲线显示训练 loss 在前 10 个 epoch 内显著下降，15~20 epoch 逐步收敛，训练过程稳定。\n• 在验证集上，整体 mAP=0.8659，mAR=0.8697，特别是在中型和大型目标上接近满分，表现出良好的检测覆盖率。\n• 单图预测结果表明模型在复杂背景下可准确检测多人并区分佩戴状态，对边界类别“佩戴不当”识别效果良好。",
                "en": "• Loss curve shows training loss drops significantly within the first 10 epochs and gradually converges from 15 to 20 epochs with stable training.\n• On the validation set, overall mAP = 0.8659 and mAR = 0.8697, with nearly perfect performance on medium and large targets, indicating good detection coverage.\n• Single image predictions demonstrate accurate multi-person detection in complex backgrounds and stable recognition of the 'improperly worn' boundary category."
              }
            },
            {
              "heading": { "zh": "总结与展望", "en": "Conclusion and Outlook" },
              "content": {
                "zh": "本项目验证了基于 Faster R-CNN 的口罩检测系统在小样本下通过迁移学习实现有效收敛的可行性，且在多场景复杂背景下具备较强的实用性和可部署性。未来可结合轻量化模型与实时推理优化，应用于更高并发要求的公共场所口罩检测场景。",
                "en": "This project verifies the feasibility of a Faster R-CNN-based mask detection system achieving effective convergence on small samples through transfer learning, demonstrating strong practicality and deployability in multi-scenario complex backgrounds. In the future, combining lightweight models and real-time inference optimizations can make it suitable for mask detection tasks in public areas with higher concurrency requirements."
              }
            }
          ],
          "images": [
            {
              "src": "/assets/img/maskDetection_model.png",
              "caption": {
                "zh": "Faster R-CNN 模型结构示意",
                "en": "Faster R-CNN Model Architecture"
              }
            },
            {
              "src": "/assets/img/maskDetection_loss.png",
              "caption": {
                "zh": "训练损失曲线",
                "en": "Training Loss Curve"
              }
            },
          ],
          "videos": []
        },


    {
  "id": "personalWebsite",
  "title": {
    "zh": "个人网站开发与部署",
    "en": "Personal Website Development and Deployment"
  },
  "description": {
    "zh": "独立设计 | React.js + AWS 部署 | 模块化组件 | 移动端适配",
    "en": "Independently Designed | React.js + AWS Deployment | Modular Components | Mobile Responsive"
  },
  "sections": [
    {
      "heading": { "zh": "项目简介", "en": "Project Overview" },
      "content": {
        "zh": "该项目是我独立开发的在线简历与作品集网站，前端基于 React.js，整体采用模块化组件架构，已通过 AWS S3 和 CloudFront 部署上线，实现自定义域名、HTTPS 访问，并对移动端进行响应式适配。",
        "en": "This project is an independently developed online resume and portfolio website built with React.js. It adopts a fully modular component architecture, is deployed on AWS S3 and CloudFront with a custom domain and HTTPS access, and is responsive for mobile devices."
      }
    },
    {
      "heading": { "zh": "功能亮点", "en": "Key Features" },
      "content": {
        "zh": "• 模块化组件开发，支持中英文切换、主题切换与 Cookie 记忆用户偏好。\n• 教育、项目等页面支持锚点定位和状态管理。\n• 自适应布局，兼容移动端和 PC 端访问体验。\n• 已通过 AWS S3 + CloudFront 部署，支持自定义域名和 HTTPS 访问。",
        "en": "• Modular component development with bilingual switching, theme switching, and cookie-based user preference memory.\n• Education, project, and other pages support anchor navigation and state management.\n• Responsive layout for a consistent experience on mobile and desktop devices.\n• Deployed on AWS S3 + CloudFront with custom domain and HTTPS access."
      }
    },
    {
      "heading": { "zh": "技术细节", "en": "Technical Details" },
      "content": {
        "zh": "• 使用 React Router 实现多页面路由与锚点管理，useState/useEffect 管理组件状态。\n• 熟练运用 React Hooks，提升了组件的复用性与可维护性。\n• 样式采用模块化及媒体查询，支持移动端响应式适配。\n• 云端托管于 S3，CloudFront 提供 HTTPS 与 CDN 加速访问。",
        "en": "• Used React Router for multi-page routing and anchor management; managed component state with useState/useEffect.\n• Proficiently utilized React Hooks to enhance component reusability and maintainability.\n• Applied modular CSS with media queries for responsive design on mobile devices.\n• Hosted on S3 with CloudFront providing HTTPS and CDN acceleration."
      }
    },
    {
      "heading": { "zh": "个人收获", "en": "Key Takeaways" },
      "content": {
        "zh": "• 独立完成前端模块化开发与多语言切换实现。\n• 熟悉路由管理、状态管理及 Hooks 使用，提升了可维护性。\n• 掌握移动端响应式布局和适配技巧。\n• 掌握 AWS 云端托管与静态网站上线能力。",
        "en": "• Independently completed modular frontend development and bilingual switching.\n• Gained proficiency in routing, state management, and practical use of React Hooks, improving maintainability.\n• Learned responsive layout and mobile adaptation techniques.\n• Acquired hands-on experience with AWS hosting and launching static websites."
      }
    }
  ],
  "images": [],
  "videos": []
}



  ],
 experienceTitle: {
    zh: "实习经历",
    en: "Experience"
  },
  experienceData: [
        

        {
          "id": "tech-support-2023",
          "date": { "zh": "2023年7月-8月", "en": "July - Aug 2023" },
          "title": {
            "zh": "技术支持工程师 - 浙江大华技术股份有限公司",
            "en": "Technical Support Engineer - Zhejiang Dahua Technology Co., Ltd."
          },
          "description": {
            "zh": "客户现场支持 | Linux调试 | tcpdump抓包 | 智能安防安装调试",
            "en": "Onsite Customer Support | Linux Debugging | tcpdump Packet Capture | CCTV Installation & Debugging"
          },
          "sections": [
            {
              "heading": { "zh": "岗位职责", "en": "Key Responsibilities" },
              "content": {
                "zh": "• 前往客户现场为智能安防及监控项目提供技术支持与定制化解决方案。\n• 安装、布线及调试监控摄像头与前端设备，确保系统正常运行。\n• 在 Linux 系统环境下进行设备调试、日志排查和权限配置。\n• 使用 tcpdump 进行网络抓包和协议分析，定位通信异常。",
                "en": "• Provided onsite technical support and customized solutions for smart security and CCTV projects.\n• Installed, wired, and debugged surveillance cameras and front-end devices to ensure proper system operation.\n• Conducted device debugging, log troubleshooting, and permission configuration in Linux environments.\n• Utilized tcpdump for network packet capture and protocol analysis to identify communication anomalies."
              }
            },
            {
              "heading": { "zh": "成果与优化", "en": "Achievements & Impact" },
              "content": {
                "zh": "• 独立完成多个监控点位的安装与调试，按期交付满足客户需求。\n• 快速排查并解决多起网络中断与数据丢包问题，提高系统稳定性。\n• 输出抓包分析报告，配合研发团队优化网络配置和固件版本。",
                "en": "• Independently completed installation and debugging of multiple surveillance points, delivering on time to meet client requirements.\n• Quickly troubleshot and resolved multiple network interruptions and packet loss issues, improving system stability.\n• Delivered packet capture analysis reports to assist the R&D team in optimizing network configurations and firmware versions."
              }
            },
            {
              "heading": { "zh": "核心技能", "en": "Key Skills & Tools" },
              "content": {
                "zh": "• 熟练掌握监控设备安装、布线与调试方法。\n• 熟悉 Linux 系统调试、日志分析与权限配置。\n• 精通 tcpdump 命令行抓包及后续分析。\n• 具备良好的客户沟通能力与跨部门协作能力。",
                "en": "• Proficient in installation, wiring, and debugging of surveillance equipment.\n• Skilled in Linux system debugging, log analysis, and permission configuration.\n• Experienced with tcpdump command-line packet capture and follow-up analysis。\n• Strong client communication and cross-functional collaboration skills."
              }
            }
          ],
          "tag": {
            "zh": ["Linux", "tcpdump", "抓包分析", "技术支持"],
            "en": ["Linux", "tcpdump", "Packet Capture", "Technical Support"]
          }
        },

        {
            "id": "embedded-dev-2023",
            "date": { "zh": "2023年9月-11月", "en": "Sept - Nov 2023" },
            "title": {
              "zh": "嵌入式软件工程师 - 广州粤嵌通信科技股份有限公司",
              "en": "Embedded Software Engineer - Guangzhou YueQian Communication Technology Co., Ltd."
            },
            "description": {
              "zh": "多媒体智能终端 | 嵌入式开发 | Linux驱动调试",
              "en": "Multimedia Smart Terminal | Embedded Development | Linux Driver Debugging"
            },
            "sections": [
              {
                "heading": { "zh": "岗位职责", "en": "Key Responsibilities" },
                "content": {
                  "zh": "• 参与多媒体智能终端嵌入式软件的需求分析与模块设计。\n• 在 Linux 环境下进行驱动调试与系统移植，确保硬件模块正常运行。\n• 编写 Shell 脚本实现系统自动化部署与调试流程。",
                  "en": "• Participated in requirement analysis and module design for embedded software of multimedia smart terminals.\n• Performed driver debugging and system porting in Linux environments to ensure proper hardware operation.\n• Developed shell scripts for automating system deployment and debugging processes."
                }
              },
              {
                "heading": { "zh": "成果与优化", "en": "Achievements & Impact" },
                "content": {
                  "zh": "• 完成音视频模块驱动调试，保证系统在指定硬件平台上稳定运行。\n• 优化系统启动脚本，缩短部署时间。\n• 与硬件及测试团队协作，及时定位并修复多项接口兼容性问题。",
                  "en": "• Completed audio-video module driver debugging to ensure stable system operation on the target hardware platform.\n• Optimized system startup scripts, reducing deployment time.\n• Collaborated with hardware and testing teams to quickly locate and fix multiple interface compatibility issues."
                }
              },
              {
                "heading": { "zh": "核心技能", "en": "Key Skills & Tools" },
                "content": {
                  "zh": "• 熟悉嵌入式 Linux 开发、驱动调试与系统移植。\n• 掌握 Shell 脚本编写及调试方法。\n• 具备多部门协作与问题定位能力。",
                  "en": "• Proficient in embedded Linux development, driver debugging, and system porting.\n• Skilled in writing and debugging shell scripts.\n• Strong cross-team collaboration and troubleshooting capabilities."
                }
              }
            ],
            "tag": {
              "zh": ["嵌入式开发", "Linux", "驱动调试", "Shell脚本"],
              "en": ["Embedded Development", "Linux", "Driver Debugging", "Shell Scripting"]
            }
          },

          {
            "id": "vosyn-internship-2025",
            "date": { "zh": "2025年9月-2026年2月", "en": "Sept 2025 - Feb 2026" },
            "title": {
              "zh": "技术与系统统筹工程师 - Vosyn",
              "en": "Technology & System Coordinator - Vosyn"
            },
            "description": {
              "zh": "云原生部署 | 业务流程自动化 | 跨部门技术支持",
              "en": "Cloud-Native Deployment | Workflow Automation | Cross-functional Support"
            },
            "sections": [
              {
                "heading": { "zh": "岗位职责", "en": "Key Responsibilities" },
                "content": {
                  "zh": "• 负责基于 GCP Linux 环境的系统架构搭建，利用 Docker 容器化技术实现 n8n 与 Botpress 等工具的快速部署与环境隔离。\n• 开发并维护 n8n 自动化工作流，取代传统手动流程，实现多平台（Google Sheets, ClickUp, Gmail）间的数据同步。\n• 协同多个部门完成技术交付，并撰写部署手册，确保了项目的平稳交接。",
                  "en": "• Managed system architecture setup on GCP Linux instances, utilizing Docker for rapid deployment and environment isolation of tools like n8n and Botpress.\n• Developed and maintained n8n automation workflows to replace manual processes, enabling seamless data synchronization across Google Sheets, ClickUp, and Gmail.\n• Collaborated with multiple team for technical delivery and authored comprehensive deployment guides."
                }
              },
              {
                "heading": { "zh": "成果与优化", "en": "Achievements & Impact" },
                "content": {
                  "zh": "• 成功构建端到端自动化业务体系，将团队内部重复性行政与财务统计工作的处理效率提升了约 50%。\n• 配置 HTTPS 加密与反向代理（Caddy/Nginx），解决跨域（CORS）问题，显著增强了云端服务的安全性与稳定性。",
                  "en": "• Built an end-to-end automated business ecosystem, improving the processing efficiency of repetitive administrative and financial tasks by approximately 50%.\n• Configured HTTPS encryption and reverse proxies (Caddy/Nginx) to resolve CORS issues, significantly enhancing cloud service security and stability."
                }
              },
              {
                "heading": { "zh": "核心技能", "en": "Key Skills & Tools" },
                "content": {
                  "zh": "• 熟练掌握 GCP 云平台运维、Linux 系统管理及 Docker 容器技术。\n• 具备高效的自动化集成能力，精通 n8n 流程设计与 JavaScript 脚本逻辑。\n• 卓越的跨部门沟通与技术统筹能力，擅长将业务需求转化为技术解决方案。",
                  "en": "• Proficient in GCP operations, Linux system administration, and Docker containerization.\n• Strong automation integration skills, expert in n8n workflow design and JavaScript logic.\n• Exceptional cross-functional communication and technical coordination skills, adept at translating business needs into technical solutions."
                }
              }
            ],
            "tag": {
              "zh": ["云原生", "自动化集成", "Docker", "跨部门协作"],
              "en": ["Cloud Native", "Automation Integration", "Docker", "Cross-functional Collaboration"]
            }
          }






  ]


  
  

};

export default translations;